import { computed, ref, watch } from '@vue/composition-api';

export const transitions = {
  slide: {
    horizontal: {
      next: {
        enter: 'slideInRight',
        leave: 'slideOutLeft',
      },
      prev: {
        enter: 'slideInLeft',
        leave: 'slideOutRight',
      },
    },
    vertical: {
      next: {
        enter: 'slideInUp',
        leave: 'slideOutUp',
      },
      prev: {
        enter: 'slideInDown',
        leave: 'slideOutDown',
      },
    },
  },
  fade: {
    horizontal: {
      next: {
        enter: 'fadeIn',
        leave: 'fadeOut',
      },
      prev: {
        enter: 'fadeIn',
        leave: 'fadeOut',
      },
    },
    vertical: {
      next: {
        enter: 'fadeIn',
        leave: 'fadeOut',
      },
      prev: {
        enter: 'fadeIn',
        leave: 'fadeOut',
      },
    },
  },
  slideFade: {
    horizontal: {
      next: {
        enter: 'fadeInRight',
        leave: 'fadeOutLeft',
      },
      prev: {
        enter: 'fadeInLeft',
        leave: 'fadeOutRight',
      },
    },
    vertical: {
      next: {
        enter: 'fadeInUp',
        leave: 'fadeOutUp',
      },
      prev: {
        enter: 'fadeInDown',
        leave: 'fadeOutDown',
      },
    },
  },
};

export function useCarouselTransitions(model, name, orientation) {
  const direction = ref('next');

  watch(model, (to, from) => {
    direction.value = from <= to ? 'next' : 'prev';
  });

  return {
    enterTransition: computed(() => transitions[name.value][orientation.value][direction.value].enter),
    leaveTransition: computed(() => transitions[name.value][orientation.value][direction.value].leave),
  };
}

export function useCarouselAutoSlide(duration) {
  const slideBus = [];

  let interval = null;

  function start() {
    if (!!duration.value) {
      interval = setInterval(() => slideBus.forEach(cb => cb(duration.value)), duration.value);
    }
  }

  function stop() {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
  }

  function restartAutoSlide() {
    stop();
    start();
  }

  function onCarouselSlide(callback) {
    slideBus.push(callback);
  }

  function pauseAutoSlide() {
    stop();
  }

  watch(
    duration,
    val => {
      if (!val) {
        return stop();
      }

      start();
    },
    { immediate: true }
  );

  return {
    restartAutoSlide,
    onCarouselSlide,
    pauseAutoSlide,
  };
}
